export const EXAMPLE_STRINGS_EN = {
  EXAMPLE_PROGRAM_WITH_ONE_RULE_CONDITION:
    'Example Program with One Rule Condition',
  EXAMPLE_ELIGIBILITY_SEGMENT_EVEN_AND_ODD_AGE:
    'Example Segment by Even and Odd Age',
  // Tenant-specific override of a default string key. The `_example` tenant
  // customizes the Example Component Page heading without the page itself
  // needing a parameter for the copy — tenants override the translation key.
  EXAMPLE_COMPONENT_PAGE_HEADING:
    'Example Page (Example Tenant String Override)',
};
